import { CustomCollapseCard, CustomTable, Text } from '@src/components';
import React, { useCallback, useEffect } from 'react';
import '@src/styles/myInvoices/baBsList.scss';
import { useDispatch, useSelector } from 'react-redux';
import { baBsGetList } from '@src/store/slice/invoiceSlice';

const BaBsList = () => {

    const dispatch = useDispatch();
    const { baBsList } = useSelector((state) => state?.invoice);
    const { selectedCustomer } = useSelector((state) => state?.customer);

    useEffect(() => {
        loadBaBsList();
    }, [dispatch]);

    const loadBaBsList = useCallback(() => {
        const body = {
            customerId: selectedCustomer?.customerId,
        };

        dispatch(baBsGetList({ body }));

    }, [dispatch, selectedCustomer]);

    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            align: 'center',
            width: 70,
        },
        {
            title: <Text t="taxNo" />,
            dataIndex: 'cus_tax_number',
            key: 'cus_tax_number',
            align: 'left',
            width: 110,
        },
        {
            title: <Text t="year" />,
            dataIndex: 'babs_year',
            key: 'babs_year',
            width: 162.7,
            align: 'center'
        },
        {
            title: <Text t="month" />,
            dataIndex: 'babs_month',
            key: 'babs_month',
            width: 90,
        },
        {
            title: <Text t="nameUpper" />,
            dataIndex: 'cus_name',
            key: 'cus_name',
            width: 270,
            height: 50,
            align: 'left',
        },
        {
            title: <Text t="invoicePrice" />,
            dataIndex: 'inv_amount',
            key: 'inv_amount',
            width: 120,
            height: 50,
            align: 'right',
        },
        {
            title: <Text t="numberOfInvoices" />,
            dataIndex: 'nb_of_invoices',
            key: 'nb_of_invoices',
            width: 120,
            height: 50,
            align: 'center',
        },
        {
            title: <Text t="type" />,
            dataIndex: 'ba_bs',
            key: 'ba_bs',
            width: 90,
            align: 'center',
        },
    ];

    return (
        <CustomCollapseCard className="babs-list-card" cardTitle={<Text t="baBsConsensus" />}>
            <CustomTable
                pagination={true}
                dataSource={baBsList}
                columns={columns}
                className="babs-list-table"
                rowKey={(record) => `babs-list-${record?.id}`}
            />
        </CustomCollapseCard>
    );
};

export default BaBsList;
